class DeviceProductForm extends HTMLElement {
  constructor() {
    super()

    // START A/B Test code
    if (window.NOOD_TEST && document.querySelector('[data-is-nood-test]')) {
      // Show Nood Test
      document
        .querySelector('.items-baseline [data-main-product-compare-at-price]')
        .parentElement.classList.add('flex', 'flex-row-reverse', 'items-center', 'gap-1')
      document.querySelector('[data-is-nood-test]').dataset.isNoodTest = true
      document.querySelectorAll('[data-nood-test-active]').forEach((el) => el.classList.remove('hidden'))

      // Remove Control
      document.querySelectorAll('[data-nood-test-control]').forEach((el) => el.remove())
    }
    // END A/B Test code

    this.isNoodTest = document.querySelector('[data-is-nood-test]')?.dataset.isNoodTest ?? false

    if (this.isNoodTest == 'true') {
      this.setupNoodAddToCart()
    } else {
      this.setupAddToCart()
    }
    this.setupPriceUpdating()
    this.setupVariantImageUpdating()
  }

  getBundleData() {
    const serumBundleData = this.querySelector('[data-serum-bundle-data]')
    if (serumBundleData) {
      console.log('Serum Bundle Data:', JSON.parse(serumBundleData.textContent))
    }
  }

  setupNoodAddToCart() {
    const serumBundleData = document.querySelector('[data-serum-bundle-data]')

    const serumBundleProducts = serumBundleData ? JSON.parse(serumBundleData.innerHTML) : null

    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    $$addToCartButtons.forEach(($addToCartButton) =>
      $addToCartButton.addEventListener('click', () => {
        $addToCartButton.dataset.loading = null

        const addToCartPayload = {
          items: [],
        }

        const bundleDiscountScriptProperty = this.querySelector('[data-bundle-discount-script-property]')
          ? this.querySelector('[data-bundle-discount-script-property]').dataset.bundleDiscountScriptProperty
          : null

        const $purchaseOption = this.querySelector('[name="purchase-option"]:checked').value
        let selling_plan_id = ''
        let variant_id = ''

        // Bundle items
        if ($purchaseOption && $purchaseOption == 'serum-bundle') {
          serumBundleProducts.forEach((product) => {
            if (product.selling_plan_groups) {
              product.selling_plan_groups.forEach((group) => {
                group.selling_plans.forEach((plan) => {
                  if (plan.name.includes('4 weeks')) {
                    selling_plan_id = plan.id
                  }

                  product.variants.forEach((variant) => {
                    if (variant.title.includes('1-Month') || variant.title.includes('1-Pack')) {
                      variant_id = variant.id
                    }
                  })
                })
              })
            }

            addToCartPayload.items.unshift({
              quantity: 1,
              id: variant_id,
              selling_plan: selling_plan_id,
              properties: {
                [bundleDiscountScriptProperty]: true,
              },
            })
          })
        }

        // Main product
        addToCartPayload.items.unshift({
          quantity: 1,
          id: Number(this.getAttribute('variant-id')),
          properties: {
            [$purchaseOption && $purchaseOption == 'serum-bundle'
              ? bundleDiscountScriptProperty
              : '_device_only_exclude']: true,
          },
        })

        const $warranty = this.querySelector('[name="warranty"]:checked')
        if ($warranty && $warranty.value != '') {
          addToCartPayload.items.unshift({
            quantity: 1,
            id: Number($warranty.value),
          })
        }

        const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
        $$addons.forEach(($addon) => {
          if ($addon.value == '') return
          addToCartPayload.items.push({
            quantity: 1,
            id: Number($addon.value),
            properties: {
              _addon: true,
            },
          })
        })

        // Auto Add-ons disabled for Nood A/B test.
        // try {
        //   const autoAddons = JSON.parse(this.getAttribute('auto-addons'))
        //   autoAddons.forEach((addon) => {
        //     addToCartPayload.items.unshift(addon)
        //   })
        // } catch (error) {
        //   console.error('Error parsing autoAddons:', error)
        // }

        const warrantyIds = [
          40117523873827, 40117526167587, 40117524463651, 40559546564643, 40559548858403, 40559546630179,
        ]
        const hasWarranty = addToCartPayload.items.some((item) => warrantyIds.includes(item.id))

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(addToCartPayload),
        })
          .then(async (response) => {
            if (!response.ok) {
              const error = await response.json()
              return alert(error.description || error.message)
            }

            if (hasWarranty) window.igEvents.push({ event: 'warranty-added-to-cart' })
            window.NSHybridCart.open()
          })
          .catch((response) => {
            console.log('Error adding to cart:', response)
          })
          .finally(() => {
            delete $addToCartButton.dataset.loading
          })
      })
    )
  }

  setupAddToCart() {
    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    $$addToCartButtons.forEach(($addToCartButton) =>
      $addToCartButton.addEventListener('click', () => {
        $addToCartButton.dataset.loading = null

        const addToCartPayload = {
          items: [],
        }

        const $kit = this.querySelector('[name="kit"]:checked')
        if ($kit && $kit.value != '') {
          addToCartPayload.items.unshift({
            quantity: 1,
            id: Number($kit.value),
          })
        } else {
          addToCartPayload.items.unshift({
            quantity: 1,
            id: Number(this.getAttribute('variant-id')),
          })
        }

        const $warranty = this.querySelector('[name="warranty"]:checked')
        if ($warranty && $warranty.value != '') {
          addToCartPayload.items.unshift({
            quantity: 1,
            id: Number($warranty.value),
          })
        }

        const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
        $$addons.forEach(($addon) => {
          if ($addon.value == '') return
          addToCartPayload.items.push({
            quantity: 1,
            id: Number($addon.value),
            properties: {
              _addon: true,
            },
          })
        })

        try {
          const autoAddons = JSON.parse(this.getAttribute('auto-addons'))
          autoAddons.forEach((addon) => {
            addToCartPayload.items.unshift(addon)
          })
        } catch (error) {
          console.error('Error parsing autoAddons:', error)
        }

        const warrantyIds = [
          40117523873827, 40117526167587, 40117524463651, 40559546564643, 40559548858403, 40559546630179,
        ]
        const hasWarranty = addToCartPayload.items.some((item) => warrantyIds.includes(item.id))

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(addToCartPayload),
        })
          .then(async (response) => {
            if (!response.ok) {
              const error = await response.json()
              return alert(error.description || error.message)
            }

            if (hasWarranty) window.igEvents.push({ event: 'warranty-added-to-cart' })
            window.NSHybridCart.open()
          })
          .catch((response) => {
            console.log('Error adding to cart:', response)
          })
          .finally(() => {
            delete $addToCartButton.dataset.loading
          })
      })
    )
  }

  setupPriceUpdating() {
    const $productVariantsData = this.querySelector('#product-variants-data')
    const productVariants = JSON.parse($productVariantsData.innerHTML)
    const automaticDiscount = Number(this.getAttribute('automatic-discount'))

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      trailingZeroDisplay: 'stripIfInteger',
    })

    const updatePrice = () => {
      const $kit = this.querySelector('[name="kit"]:checked')
      const $warranty = this.querySelector('[name="warranty"]:checked')
      const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
      const $purchaseOption = this.querySelector('[name="purchase-option"]:checked')?.parentElement

      let price = 0
      let compareAtPrice = 0
      let totalPrice = 0

      if ($purchaseOption && window.NOOD_TEST) {
        const $purchaseOptionPrice = $purchaseOption.querySelector('[data-purchase-option-price]')
        const $purchaseOptionComparePrice = $purchaseOption.querySelector('[data-purchase-option-compare-price]')

        price = parseFloat($purchaseOptionPrice.textContent.replace(/[^0-9.]/g, '')) * 100
        compareAtPrice = $purchaseOptionComparePrice
          ? parseFloat($purchaseOptionComparePrice.textContent.replace(/[^0-9.]/g, '')) * 100
          : 0
      } else {
        let variant = productVariants[0]
        if ($kit && $kit.value != '') {
          const foundVariant = productVariants.find((v) => v.id == $kit.value)
          if (!foundVariant) return console.error('Variant not found')
          variant = foundVariant
        }
        price += variant.price - automaticDiscount
        compareAtPrice += variant.compare_at_price || variant.price
      }

      totalPrice += price

      if ($warranty && $warranty.value != '') {
        totalPrice += parseInt($warranty.dataset.price) || 0
      }

      $$addons.forEach(($addon) => {
        if ($addon.value == '') return
        totalPrice += parseInt($addon.dataset.price) || 0
      })

      const $$price = document.querySelectorAll('[data-main-product-price]')
      const $$compareAtPrice = document.querySelectorAll('[data-main-product-compare-at-price]')
      const $$totalPrice = document.querySelectorAll('[data-main-product-total-price]')

      const formattedPrice = formatter.format(price / 100)
      $$price.forEach(($price) => {
        $price.innerHTML = formattedPrice
      })

      const formattedTotalPrice = formatter.format(totalPrice / 100)
      $$totalPrice.forEach(($totalPrice) => {
        $totalPrice.innerHTML = formattedTotalPrice
      })

      if (compareAtPrice > price) {
        const formattedCompareAtPrice = formatter.format(compareAtPrice / 100)
        $$compareAtPrice.forEach(($compareAtPrice) => {
          $compareAtPrice.innerHTML = formattedCompareAtPrice
          $compareAtPrice.classList.remove('hidden')
        })
      } else {
        $$compareAtPrice.forEach(($compareAtPrice) => $compareAtPrice.classList.add('hidden'))
      }

      // TEST - Update promo text
      function updatePromoText() {
        if (window.IG_TEST_PERCENT) {
          const $$promoText = document.querySelectorAll('[data-promo-text]')
          $$promoText.forEach(($promoText) => {
            if ($promoText.textContent.trim() == '') return

            let originalText
            if ($promoText.dataset.originalText) originalText = $promoText.dataset.originalText
            else $promoText.dataset.originalText = $promoText.textContent

            const priceMatch = $promoText.dataset.originalText.match(/\$([\d,.]+)/)
            if (priceMatch) $promoText.dataset.price = priceMatch[1]

            $promoText.dataset.price = parseFloat($promoText.dataset.price?.replace(',', ''))

            const percentOff = ($promoText.dataset.price / (compareAtPrice / 100)) * 100

            $promoText.textContent = `${$promoText.dataset.originalText.replace(/\$([\d,.]+)/, `${percentOff.toFixed(0)}%`)}`

            $promoText.dataset.loaded = true
          })
        }
      }

      if (!window.igData) {
        window.addEventListener('ig:ready', updatePromoText)
      } else {
        updatePromoText()
      }
    }

    const $$selectors = this.querySelectorAll(
      '[name="kit"], [name="warranty"], [name="addon-product"], [name="purchase-option"]'
    )
    $$selectors.forEach(($selector) => $selector.addEventListener('change', updatePrice))
    // init
    updatePrice()
  }

  setupVariantImageUpdating() {
    const hideImage = ($image) => {
      $image.classList.add('opacity-0')
      setTimeout(() => $image.classList.add('hidden'), 300)
    }

    const showImage = ($image) => {
      $image.classList.remove('hidden')
      setTimeout(() => $image.classList.remove('opacity-0'), 50)
    }

    const $section = this.closest('section')
    const $$kitSelectors = $section.querySelectorAll('[name="kit"]')
    $$kitSelectors.forEach(($kitSelector) => {
      $kitSelector.addEventListener('change', () => {
        // Desktop
        const $$desktopVariantImages = $section.querySelectorAll('[data-product-media-desktop] [data-variant-image]')
        if ($$desktopVariantImages.length === 0) return

        const position = $kitSelector.dataset.variantImage
        const $kitDesktopImage = $section.querySelector(
          '[data-product-media-desktop] [data-variant-image="' + position + '"]'
        )

        const $mainImage = $$desktopVariantImages[0].parentNode.querySelector('img:not([data-variant-image])')
        if (position === '') showImage($mainImage)
        else hideImage($mainImage)

        $$desktopVariantImages.forEach(($desktopVariantImage) => {
          if ($desktopVariantImage === $kitDesktopImage) return
          hideImage($desktopVariantImage)
        })

        if ($kitDesktopImage) showImage($kitDesktopImage)

        // Mobile
        const $mainMobileSplide = $section.querySelector('#product-media-splide')
        if (!$mainMobileSplide) return
        $mainMobileSplide.splide.go(parseInt(position) - 1 || 0)
      })
    })
  }
}

customElements.define('device-product-form', DeviceProductForm)
